import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loadBootFiles } from './api/bootFiles';
import './index.css';

// Mounts the storefront: a page the server already drew is taken over as it stands (hydrated), so nothing the shopper
// sees is drawn twice; a page that came without a drawing is drawn here, as before. Taking a page over is done as a
// transition, which React works through in short slices: the shopper is already looking at the page, and one long task
// would hold up their first tap. A drawn page names its first answers as files, read first, since the drawing was made
// from them; if they cannot be read, the page is drawn afresh from the API rather than taken over from the wrong data.
const root = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
void loadBootFiles().then(
  () => {
    if (root.firstElementChild) React.startTransition(() => { ReactDOM.hydrateRoot(root, app); });
    else ReactDOM.createRoot(root).render(app);
  },
  () => ReactDOM.createRoot(root).render(app)
);
